import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { ReferenceDataService } from "../services/referencedata.service";


@Injectable()
export class CountryResolve implements Resolve<any> {

    constructor(private refService: ReferenceDataService) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        var enabledOnly = false;
        if (route.data['enabledOnly'] != null) {
            enabledOnly = (route.data['enabledOnly'] == true) ? true : false;
        }

        return new Promise<any>((resolve, reject) => {
            this.refService.getCountries(enabledOnly).subscribe(
                (data) => {
                    resolve(data);
                });
        }).then(function (data) {
            return data;
        });

    }

}